export const CLAIM_REASONS = [
  'BOX_SHORTAGE',
  'PIECES_SHORT',
  'PIECES_DAMAGED',
  'WRONG_BOX_DELIVERED'
];

export const CLIENT_STATUS_FILTERS = [
  'CREATED',
  'UNDER_VERIFICATION',
  'UNDER_INVESTIGATION',
  'RCA_SUBMITTED',
  'RCA_APPROVED',
  'INVESTIGATED',
  'ACKNOWLEDGEMENT_PENDING',
  'ACKNOWLEDGEMENT_COMPLETED',
  'CLAIM_PENDING',
  'SETTLEMENT_PENDING',
  'APPROVED',
  'REJECTED',
  'REVOKED'
];

export const CLIENT_STATUS_GROUPINGS = {
  UNDER_INVESTIGATION: [
    'UNDER_INVESTIGATION',
    'RCA_SUBMITTED',
    'RCA_APPROVED',
    'INVESTIGATED',
    'RCA_PENDING'
  ],
  ACKNOWLEDGEMENT_COMPLETED: [
    'ACKNOWLEDGEMENT_COMPLETED',
    'CLAIM_PENDING',
    'OPS_HOD_APPROVAL_PENDING',
    'SALES_HOD_APPROVAL_PENDING'
  ]
};

export const EDITABLE_STATUSES = ['CREATED', 'UNDER_VERIFICATION'];

export const REVOCABLE_STATUSES = ['CREATED', 'UNDER_VERIFICATION'];

const CLIENT_STATUS_DISPLAY_MAP = {
  CREATED: 'Created',
  UNDER_VERIFICATION: 'Under Review',
  UNDER_INVESTIGATION: 'Under Investigation',
  RCA_PENDING: 'Under Investigation',
  RCA_SUBMITTED: 'Under Investigation',
  RCA_APPROVED: 'Under Investigation',
  INVESTIGATED: 'Investigated',
  ACKNOWLEDGEMENT_PENDING: 'Acknowledgement Pending',
  ACKNOWLEDGEMENT_COMPLETED: 'Acknowledgement Completed',
  CLAIM_PENDING: 'Claim Pending',
  OPS_HOD_APPROVAL_PENDING: 'Claim Pending',
  SALES_HOD_APPROVAL_PENDING: 'Claim Pending',
  SETTLEMENT_PENDING: 'Settlement Pending',
  APPROVED: 'Settled',
  REJECTED: 'Rejected',
  REVOKED: 'Revoked'
};

export const getClientVisibleStatus = (status: string, isRework?: boolean) => {
  const mappedStatus =
    CLIENT_STATUS_DISPLAY_MAP[status] ||
    (status ? status.replace(/_/g, ' ') : '--');
  return isRework ? `${mappedStatus} (Rework)` : mappedStatus;
};

export const isClaimEditableForClient = (status: string, isRework?: boolean) =>
  EDITABLE_STATUSES.includes(status) || !!isRework;

export const isClaimRevocableForClient = (status: string) =>
  REVOCABLE_STATUSES.includes(status);
